const swiper = new Swiper(".swiper", {
  loop: true, // ループ有効
  slidesPerView: 4.6, // 一度に表示する枚数
  speed: 8000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});


const sp_swiper = new Swiper(".swiper_sp", {
  loop: true, // ループ有効
  slidesPerView: 3, // 一度に表示する枚数
  speed: 8000, // ループの時間
  allowTouchMove: false, // スワイプ無効
  autoplay: {
    delay: 0, // 途切れなくループ
  },
});